export default "__VITE_ASSET__CkmdgGnK__"